import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';
import Konva from 'konva';
import { useTheme } from 'services/theme';



import ballImg from '../img/ball.png';
import { hexToRgb } from 'services/utils/color';

 const Ball = ({ xPos, yPos, width, height }) => {
     const [image] = useImage(ballImg);
     const theme = useTheme();
     const hexBallColor = theme['accent-color'];
     const rgbBallColor = hexToRgb(hexBallColor);

     const imageRef = React.useRef();

     // when image is loaded we need to cache the shape
     React.useEffect(() => {
       if (image) {
         // you many need to reapply cache on some props changes like shadow, stroke, etc.
         imageRef.current.cache();
       }
     }, [image]);

    return (
        <Image
            ref={imageRef}
            image={image}
            x={xPos}
            y={yPos}
            width={width}
            height={height}
            red={rgbBallColor.r}
            green={rgbBallColor.g}
            blue={rgbBallColor.b}
            filters={[Konva.Filters.Grayscale, Konva.Filters.RGB]}
        />
    );
 };

 export default Ball;